// extracted by mini-css-extract-plugin
export default {"wrapper":"_3L7CZ"};